import React, { useState, useEffect } from 'react';
import { db } from '../../firebase/firebaseConfig';
import { ref, get, remove, update } from 'firebase/database';
import { Link } from 'react-router-dom';

function AdminProfiles() {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchProfiles();
  }, []);

  const fetchProfiles = async () => {
    try {
      setLoading(true);
      const usersRef = ref(db, 'users');
      const snapshot = await get(usersRef);
      if (snapshot.exists()) {
        const usersObj = snapshot.val();
        const profilesList = Object.keys(usersObj)
          .map(key => ({
            uid: key,
            ...usersObj[key]
          }))
          .filter(u => u.profileId); // Only users with a Profile ID
        
        setProfiles(profilesList.reverse());
      } else {
        setProfiles([]);
      }
    } catch (error) {
      console.error("Error fetching profiles:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteProfile = async (uid) => {
    if (window.confirm("Disable this developer profile? This will revoke the Profile ID and break any active embeds.")) {
      try {
        await update(ref(db, `users/${uid}`), {
          profileId: null,
          githubUsername: "",
          leetcodeUsername: "",
          codeforcesUsername: "",
          gfgUsername: ""
        });
        fetchProfiles();
      } catch (error) {
        alert("Error disabling profile: " + error.message);
      }
    }
  };

  const filteredProfiles = profiles.filter(p => 
    (p.profileId && p.profileId.toLowerCase().includes(search.toLowerCase())) ||
    (p.github && p.github.toLowerCase().includes(search.toLowerCase())) ||
    (p.leetcode && p.leetcode.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div className="animate-up">
      <div className="admin-page-header">
        <h1>Active Profiles</h1>
        <p>Monitor public developer statistics portfolios.</p>
      </div>

      <div className="admin-card">
        <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '20px'}}>
          <div style={{position: 'relative', width: '300px'}}>
            <i className="fa-solid fa-search" style={{position:'absolute', top:'12px', left:'15px', color:'#8b949e'}}></i>
            <input 
              type="text" 
              placeholder="Search by ID or handle..." 
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: '100%', padding: '10px 10px 10px 40px', background: 'rgba(0,0,0,0.2)',
                border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: '8px', fontSize: '0.9rem'
              }}
            />
          </div>
          <button onClick={fetchProfiles} className="btn" style={{background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: '8px', padding: '0 15px'}}>
            <i className="fa-solid fa-arrows-rotate"></i>
          </button>
        </div>

        {loading ? (
          <div style={{padding: '40px', textAlign: 'center', color: '#8b949e'}}>Loading profiles...</div>
        ) : (
          <div className="admin-table-container">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Profile Link</th>
                  <th>GitHub</th>
                  <th>LeetCode</th>
                  <th>Codeforces</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredProfiles.length === 0 ? (
                  <tr><td colSpan="5" style={{textAlign: 'center', padding: '30px', color: '#8b949e'}}>No profiles found.</td></tr>
                ) : (
                  filteredProfiles.map(profile => (
                    <tr key={profile.uid}>
                      <td>
                        <Link to={`/dev/${profile.profileId}`} target="_blank" style={{color: '#00ffae', textDecoration: 'none', fontWeight: '500'}}>
                          {profile.profileId} <i className="fa-solid fa-arrow-up-right-from-square" style={{fontSize: '0.75rem', marginLeft:'5px'}}></i>
                        </Link>
                      </td>
                      <td>{profile.githubUsername ? <span style={{color: '#fff'}}><i className="fa-brands fa-github"></i> {profile.githubUsername}</span> : <span style={{color: '#8b949e'}}>-</span>}</td>
                      <td>{profile.leetcodeUsername ? <span style={{color: '#ffa116'}}><i className="fa-solid fa-code"></i> {profile.leetcodeUsername}</span> : <span style={{color: '#8b949e'}}>-</span>}</td>
                      <td>{profile.codeforcesUsername ? <span style={{color: '#318ce7'}}><i className="fa-solid fa-chart-simple"></i> {profile.codeforcesUsername}</span> : <span style={{color: '#8b949e'}}>-</span>}</td>
                      <td>
                        <button onClick={() => handleDeleteProfile(profile.uid)} title="Disable Profile" style={{color: '#ff375f', cursor: 'pointer', background: 'rgba(255,55,95,0.1)', padding: '6px 10px', borderRadius: '6px', border: 'none'}}>
                          <i className="fa-solid fa-trash-can"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminProfiles;
